import { isRecord } from '@/utils/filter/isRecord';

/**
 * Unwraps the S3 filter response envelope.
 * Some responses wrap the actual filter data inside a `filters` property.
 */
export const unwrapS3Response = (responseData: Record<string, unknown>): Record<string, unknown> => {
  const filters = responseData.filters;
  return isRecord(filters) ? filters : responseData;
};

const S3_HOST_PATTERN = /^(?:[a-z0-9.-]+\.)?s3(?:[.-][a-z0-9-]+)*\.amazonaws\.com$/;

export const isAllowedDownloadUrl = (url: URL): boolean =>
  url.protocol === 'https:' && S3_HOST_PATTERN.test(url.hostname);

/**
 * Validates that a download URL points to an expected S3 host.
 * Throws if the URL is malformed or not an allowed download URL.
 */
export const validateS3Url = (url: string): void => {
  if (!isAllowedDownloadUrl(new URL(url))) {
    throw new Error('Invalid download URL');
  }
};
